import { useIsActiveRoute } from '@larvitu/shared/next/utils';
import { Children, cloneElement } from 'react';

import type { FC, ReactElement } from 'react';

export interface ActiveRoteProps {
  path: string;
  children: ReactElement;
}

/**
 * @deprecated -  use ActiveRouteController instead
 */
export const WithActiveRoute: FC<ActiveRoteProps> = ({
  path = '',
  children,
  ...props
}) => {
  const { isActive } = useIsActiveRoute( path );

  return (
    <>
      {Children.map( children, (child) => cloneElement( child, { active: isActive, ...props } ) )}
    </>
  );
};
